module.exports = __webpack_public_path__ + "static/media/marotte-black.5cc45a2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brands/marotte-black.svg
// module id = 329
// module chunks = 37